/* Bomba il camion: artwork mostrato un attimo quando si tocca il camion (dati in gm-camion-art-1..4.js) */
window.GM_ART = 'data:image/png;base64,' + (window.GM_ART_P || []).join('').replace(/\s+/g, '');
